import React from "react";
import { Container } from "@mui/system";
import { Grid, Typography, Box } from "@mui/material";
import globals from "../globals";
import RedButton from "../components/redButton";
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingPage() {

    return (
        <Container>
            <Grid container justifyContent="space-evenly" alignItems="center" >
                <Grid item textAlign={'center'} xs={10} sm={5}>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, fontWeight: 'bold' }}>Моля, изчакайте...</Typography>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt:2, mb:4 }}>Още миг и продължаваме напред!</Typography>
                    <CircularProgress sx={{color: globals.colors.lightRed}}/>
                </Grid>
                <Grid item xs={10} sm={4}>
                    <img src='/please-wait-page.webp' style={{ height: 300, width: 300 }}></img>
                </Grid>
            </Grid>
        </Container>
    );
}